import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth0 } from "../react-auth0-spa";

import { API_URL } from "../../constants/constants";

export const usePatchDestinatarios = () => {
  // console.log(initialUser);
  // const [user, setUser] = useState();
  const [body, setBody] = useState({});
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { getTokenSilently, user } = useAuth0();

  useEffect(() => {
    // console.log(body);

    if (Object.keys(body).length === 0) return;
    const patchDestinatarios = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const { nombre, correo, telefono, empresa = "Dr. Envio", _id } = body;
        // console.log(alto, ancho, largo);

        const t = await getTokenSilently();
        const r = await axios.patch(
          API_URL + `/destinatarios/${user.sub}`,
          {
            nombre,
            correo,
            telefono,
            empresa,
            _id
          },
          {
            headers: {
              // "Access-Control-Allow-Origin": "*",
              Authorization: `Bearer ${t}`
            }
          }
        );
        setData(r.data);
        // console.log(r.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      }
      setIsLoading(false);
    };
    patchDestinatarios();
  }, [body,getTokenSilently,user.sub]);

  return [{ data, isLoading, isError }, setBody];
};

export default usePatchDestinatarios;
